import React, { useState, useEffect } from 'react';
import styles from './Table.module.scss';
import moment from 'moment';
import { getTranslation } from '../../../utils/translation';

export default function ResultsTable({ data }) {
    const [periodNames, setPeriodNames] = useState([]);

    useEffect(() => {
        let periodNamesArr = [];
        if (data) {
            for (var i = 0; i < data.results.length; i++) {
                if ('eventPeriodScores' in data.results[i]) {
                    if (Object.keys(data.results[i].eventPeriodScores).length === data.periodNum) {
                        periodNamesArr = Object.keys(data.results[i].eventPeriodScores);
                        break;
                    }
                }
            }
            setPeriodNames(periodNamesArr);
        }
    }, [data]);

    const getPeriodNames = data => {
        let periodNames = [];
        if (data) {
            for (var i = 0; i < data.results.length; i++) {
                if ('eventPeriodScores' in data.results[i]) {
                    if (Object.keys(data.results[i].eventPeriodScores).length === data.periodNum) {
                        periodNames = Object.keys(data.results[i].eventPeriodScores);
                        break;
                    }
                }
            }
        }
        return (
            periodNames.length > 0 &&
            periodNames.map((period, index) => <th key={index}>{period}</th>)
        );
    };

    return (
        <table className={styles.table}>
            <thead>
                <tr align='center'>
                    <th align={'left'} style={{ paddingLeft: '18px' }}>
                        {getTranslation('resultsTableEventDateColumn')}
                    </th>
                    <th>{getTranslation('resultsTableEventIdColumn')}</th>
                    <th>{getTranslation('resultsTableCategoryColumn')}</th>
                    <th>{getTranslation('resultsTableLeagueColumn')}</th>
                    <th>{getTranslation('resultsTableEventColumn')}</th>
                    {getPeriodNames(data)}
                    <th>{getTranslation('resultsTableFullTimeColumn')}</th>
                </tr>
            </thead>

            <tbody align='center'>
                {data.results.map((result, index) => (
                    <tr key={result.eventId}>
                        <td align='left'>{moment(result.date).format('DD/MM/YYYY HH:mm')}</td>
                        <td>
                            <span className={styles.eventId}>{result.eventId}</span>
                        </td>
                        <td>{result.category}</td>
                        <td>{result.league}</td>
                        <td>{result.event}</td>
                        {Object.entries(result.eventPeriodScores).length === 0
                            ? [...Array(data.periodNum)].map((period, index) => (
                                  <td key={index}>0:0</td>
                              ))
                            : periodNames.map((score, i) => (
                                  <td key={i}>
                                      {result.eventPeriodScores[score]
                                          ? result.eventPeriodScores[score]
                                          : '0:0'}
                                  </td>
                              ))}
                        <td>{result.fullTimeScore}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
